/**
 * Entity formatting utilities
 * Migrated from front/src/entityPageHelpers.js
 */

/**
 * Entity type formatting for display
 */
export const formattedEntity = {
  commune: 'commune',
  epci: 'EPCI',
};

/**
 * Entity type formatting with articles (la/l')
 */
export const formattedTheEntity = {
  commune: 'la commune',
  epci: "l'EPCI",
};

/**
 * Mapping des noms de domaines géographiques avec articles
 * @type {Object<string, string>}
 */
const DOMAIN_WITH_ARTICLE = {
  'Réunion': 'La Réunion',
  'Mayotte': 'Mayotte',
  'Guyane': 'la Guyane',
  'Guadeloupe': 'la Guadeloupe',
  'Martinique': 'la Martinique',
  'Saint-Martin-Saint-Barthélemy': 'les îles de Saint-Martin et Saint-Barthélemy',
  'Nouvelle-Calédonie': 'la Nouvelle-Calédonie',
  'Polynésie-française-Australes': 'les îles Australes du nord',
  'Polynésie-française-Tuamotu': 'les îles Tuamotu du nord-ouest',
  'Polynésie-française-Société': 'les îles de la Société',
};

/**
 * Formate le nom de domaine (sans article)
 * @param {string|undefined} domaine - Valeur brute de entity.domaine
 * @returns {string} Nom du domaine sans article (ex: "Réunion", "Mayotte", "France hexagonale")
 *
 * @example
 * formatDomain("Réunion")   // => "Réunion"
 * formatDomain("Mayotte")   // => "Mayotte"
 * formatDomain(undefined)   // => "France hexagonale"
 */
export const formatDomain = (domaine) => {
  if (!domaine) {
    return 'France hexagonale';
  }

  return domaine;
};

/**
 * Formate le nom de domaine avec l'article approprié
 * @param {string|undefined} domaine - Valeur brute de entity.domaine
 * @returns {string} Nom du domaine avec article (ex: "La Réunion", "Mayotte", "la France hexagonale")
 *
 * @example
 * formatDomainWithArticle("Réunion")  // => "La Réunion"
 * formatDomainWithArticle("Mayotte")  // => "Mayotte"
 * formatDomainWithArticle(undefined)  // => "la France hexagonale"
 */
export const formatDomainWithArticle = (domaine) => {
  if (!domaine) {
    return 'la France hexagonale';
  }

  return DOMAIN_WITH_ARTICLE[domaine] || domaine;
};

/**
 * Print styles for text size optimization
 * Used across multiple components for consistent print rendering
 */
export const printTextSize = {
  '@media print': {
    fontSize: '0.9em'
  }
};
